import React from "react";
import { Input, Textarea } from "../../";
import locales from "../../../constants"

const ThirdStep = ({ register, errors, step, setStep, lang }) => {
  const translation = locales[lang]
  return (
    <div
      className="step_3 stepWrapper"
      style={{ display: step === 3 ? "block" : "none" }}
    >
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_social_head}</h4>
          <p>{translation.brief_shop.step_3_social_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="social_integration"
            label= {translation.brief_shop.step_3_social}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_allegro_head}</h4>
          <p>{translation.brief_shop.step_3_allegro_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="shop_integration"
            label= {translation.brief_shop.step_3_allegro}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4> {translation.brief_shop.step_3_blog_head}</h4>
          <p>{translation.brief_shop.step_3_blog_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="blog"
            label={translation.brief_shop.step_3_blog}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4> {translation.brief_shop.step_3_courier_head}</h4>
          <p>{translation.brief_shop.step_3_courier_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="delivery_integration"
            label={translation.brief_shop.step_3_courier}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_salers_head}</h4>
          <p>{translation.brief_shop.step_3_salers_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="wholesale"
            label={translation.brief_shop.step_3_salers}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_payment_head}</h4>
          <p>{translation.brief_shop.step_3_payment_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="payment"
            label= {translation.brief_shop.step_3_payment}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_delivery_head}</h4>
          <p>{translation.brief_shop.step_3_delivery_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="delivery"
            label={translation.brief_shop.step_3_delivery}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_system_head}</h4>
          <p>{translation.brief_shop.step_3_system_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="other_integrations"
            label={translation.brief_shop.step_3_system}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_partner_head}</h4>
          <p>{translation.brief_shop.step_3_partner_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="partners_system"
            label= {translation.brief_shop.step_3_partner}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_newsletter_head}</h4>
          <p>{translation.brief_shop.step_3_newsletter_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="newsletter"
            label= {translation.brief_shop.step_3_newsletter}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_configuration_head}</h4>
          <p>
          {translation.brief_shop.step_3_configuration_desc}
          </p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="products_configuration"
            label= {translation.brief_shop.step_3_configuration}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_opinions_head}</h4>
          <p>
          {translation.brief_shop.step_3_opinions_desc}
          </p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="opinions"
            label= {translation.brief_shop.step_3_opinions}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_searcher_head}</h4>
          <p>
          {translation.brief_shop.step_3_searcher_desc}
          </p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="search"
            label= {translation.brief_shop.step_3_searcher}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_special_head}</h4>
          <p>{translation.brief_shop.step_3_special_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="requirements"
            label= {translation.brief_shop.step_3_special}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_migration_products_head}</h4>
          <p>{translation.brief_shop.step_3_migration_products_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="product_migration"
            label= {translation.brief_shop.step_3_migration_products}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_migration_other_head}</h4>
          <p>
          {translation.brief_shop.step_3_migration_other_desc}
          </p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="other_migration"
            label= {translation.brief_shop.step_3_migration_other}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_3_functionalities_head}</h4>
          <p>{translation.brief_shop.step_3_functionalities_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="additional_functionalities"
            label= {translation.brief_shop.step_3_functionalities}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="btn-brief-group">
        <button
          type="button"
          className="btn_brief stepWrapperBtn"
          onClick={() => setStep(2)}
        >
          {translation.brief_shop.step_1_prev_step}
        </button>

        <button
          type="button"
          className="btn_brief stepWrapperBtn"
          onClick={() => setStep(4)}
        >
          {translation.brief_shop.step_1_next_step}
        </button>
      </div>
    </div>
  );
};

export default ThirdStep;
